import { render, staticRenderFns } from "./ComponentConcernElements.vue?vue&type=template&id=16e56192&"
import script from "./ComponentConcernElements.vue?vue&type=script&lang=js&"
export * from "./ComponentConcernElements.vue?vue&type=script&lang=js&"
import style0 from "./ComponentConcernElements.vue?vue&type=style&index=0&id=16e56192&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports